var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.864,2.500 L17.500,18.864 L1.136,2.500"}));
}

ArrowDown.displayName = "ArrowDown";

ArrowDown.defaultProps = {"width":"35","height":"30","viewBox":"0 -5.5 35 30"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
